// Stub for UI — xtracker uses its own HTML/CSS UI, not the canvas-based bassoon UI.
var UI = function(){
	var me = {};
	me.mainPanel = { width: 1024, height: 768 };
	me.stats = {};
	me.getCanvas = function(){ return null; };
	me.setInfo = function(){};
	me.setLoading = function(){};
	me.setStatus = function(){};
	me.setModalElement = function(){};
	me.showDialog = function(){};
	me.initPlugin = function(){};
	me.skipFrame = function(){};
	me.getSkipFrame = function(){ return 1; };
	me.scaleToDevicePixelRatio = function(){};
	me.measure = function(){};
	me.endMeasure = function(){};
	return me;
}();

export default UI;
